/* eslint-disable import/prefer-default-export */
const API_CONFIG = {
  SKU_DATA_DB_ENDPOINT: "https://supernova.avataar.me",
  S3_UPLOAD_ENDPOINT: "https://d2a0nf2ti9aoo3.cloudfront.net",
  SKU_DATA_S3_ENDPOINT: "https://demj0ontputmf.cloudfront.net",
  GA_TRACKING_ID: "G-JV9DBZ0H6K",
  ENABLE_LOGS: false,
};


export { API_CONFIG };
